import { Injectable, Injector, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

/**
 * Resolves Angular route `title` values as ngx-translate keys (e.g. ROUTES.ADMIN.DASHBOARD).
 * Re-applies the document title when the active language changes.
 *
 * Router is resolved lazily via Injector to avoid NG0200:
 * Router → NavigationTransitions → TitleStrategy → Router.
 */
@Injectable()
export class TranslateTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);
  private readonly translate = inject(TranslateService);
  private readonly injector = inject(Injector);

  constructor() {
    super();
    this.translate.onLangChange.subscribe(() => {
      const router = this.injector.get(Router);
      this.updateTitle(router.routerState.snapshot);
    });
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const key = this.buildTitle(snapshot);
    if (!key) {
      return;
    }
    const translated = this.translate.instant(key);
    this.title.setTitle(translated === key ? key : translated);
  }
}
